import React, { useState, useEffect, useRef } from 'react'
import { manualAttendanceTableList, approveManualAttendance, rejectManualAttendance } from '../../../../../API/API'

import classes from './NotifTabs.module.scss'
import { toast } from 'react-hot-toast';

const ManualAtt = ({ handleChange }) => {
    const [tableData, setTableData] = useState([]);
    const [dataChange, setDataChange] = useState(0);

    const PROBLEM_APPROVING = useRef(null);
    const PROBLEM_REJECTING = useRef(null);
    const PROBLEM_NOTIFICATION_SERVICES = useRef(null);
    const PROBLEM_LOADING_MAN_ATT = useRef(null);

    const ATTENDANCE_APPROVED = useRef(null);
    const ATTENDANCE_REJECTED = useRef(null);

    const data = JSON.parse(localStorage.getItem('data'));
    const userID = localStorage.getItem('userID');

    useEffect(() => {
        if (window.env) {
            //Error Handling 
            PROBLEM_APPROVING.current = window.env.ERROR.PROBLEM_APPROVING;
            PROBLEM_REJECTING.current = window.env.ERROR.PROBLEM_REJECTING;
            PROBLEM_LOADING_MAN_ATT.current = window.env.ERROR.PROBLEM_NOTIFICATION_SERVICES;
            PROBLEM_NOTIFICATION_SERVICES.current = window.env.ERROR.PROBLEM_NOTIFICATION_SERVICES;

            //Success Handling
            ATTENDANCE_APPROVED.current = window.env.SUCCESS.ATTENDANCE_APPROVED;
            ATTENDANCE_REJECTED.current = window.env.SUCCESS.ATTENDANCE_REJECTED;
        } else {
            toast("Problem in getting env file", {
                duration: 4500,
                icon: "❗",
            });
        }

        if (data && userID) {
            manualAttendanceTableList(userID, data.empid, data.token)
                .then(response => {
                    setTableData(response.data)
                    setDataChange(0)
                })
                .catch((error) => {
                    toast(PROBLEM_LOADING_MAN_ATT.current, {
                        icon: "❗",
                        duration: 4500
                    }
                    )
                })
        }
    }, [dataChange])

    const approve = (id) => {
        approveManualAttendance(userID, data.empid, data.token, id)
            .then(res => {
                if (res.data.success === "APPROVED") {
                    setDataChange(1)
                    handleChange(1)
                    toast.success(ATTENDANCE_APPROVED.current, {
                        duration: 2500
                    })
                } else {
                    toast(PROBLEM_APPROVING.current, {
                        icon: "❗",
                        duration: 4500
                    })
                }
            })
            .catch(error => {
                toast(PROBLEM_NOTIFICATION_SERVICES.current, {
                    icon: "❗",
                    duration: 4500
                })
            })
    }

    const reject = (id, index) => {
        rejectManualAttendance(userID, data.empid, data.token, id)
            .then(res => {
                console.log(res)
                if (res.data.success === "REJECTED") {
                    setDataChange(1)
                    handleChange(1)
                    toast.success(ATTENDANCE_REJECTED.current, {
                        duration: 2500
                    })
                } else {
                    toast(PROBLEM_REJECTING.current, {
                        icon: "❗",
                        duration: 4500
                    })
                }
            })
            .catch(error => {
                toast(PROBLEM_NOTIFICATION_SERVICES.current, {
                    icon: "❗",
                    duration: 4500
                })
            })


    }


    return (
        <div>
            {tableData !== null && tableData.length > 0 ? tableData.map((item, index) => {
                return (
                    
                        <div className={classes[`ManualAttDivs`]} key={index}>
                            <div className={classes.NameDesig}>
                                <p><b>Name: </b>{item.nd.split(',')[0]}</p>
                                <p><b>Designation: </b>{item.nd.split(',')[1]}</p>
                                <p><b>Date:</b> {item.dt}</p>
                            </div>
                            <div className={classes.TimingInfo}>
                                <div className={classes.Info}>
                                    <p><b>In Time:</b> <br />{item.in_time.substring(0, 5)}</p>
                                    <p><b>Out Time:</b> <br />{item.out_time.substring(0, 5)}</p>
                                </div>
                                <div className={classes.Info}>
                                    <p><b>In Location:</b> <br />{item.in_from !== null ? item.in_from.replace(/_/g, " ") : "No In Location"}</p>
                                    <p><b>Out Location:</b> <br />{item.out_from !== null ? item.out_from.replace(/_/g, " ") : "No Out Location"}</p>
                                </div>
                            </div>
                            <div>
                                <p><b>Remarks:</b> {item.remarks}</p>
                            </div>
                            <div className={classes.Buttons}>
                                <button onClick={() => { approve(item.punch_id) }}>APPROVE</button>
                                <button onClick={() => { reject(item.punch_id) }}>REJECT</button>
                            </div>
                        </div>
                 
                )
            }) : <h4 style={{ marginTop: "20px", textAlign: "center" }}> No Attendance Approvals To show</h4>}
        </div>
    )
}

export default ManualAtt
